(function () {
  function initVisibilityObserver(bar) {
    var targetId = bar.getAttribute('data-observe-target');
    var target = targetId ? document.getElementById(targetId) : null;
    if (!target || !('IntersectionObserver' in window)) return;

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          var scrolledPast = !entry.isIntersecting && entry.boundingClientRect.top < 0;
          bar.classList.toggle('is-visible', scrolledPast);
        });
      },
      { threshold: 0 }
    );

    observer.observe(target);
  }

  function initQuantitySync(sectionId) {
    var stickyInput = document.getElementById('StickyQuantity-' + sectionId);
    var mainInput = document.getElementById('Quantity-' + sectionId);
    if (!stickyInput || !mainInput) return;

    function syncMinusDisabled(input) {
      var minusButton = input.previousElementSibling;
      if (!minusButton) return;
      minusButton.classList.toggle('disabled', Number(input.value) <= Number(input.min || 1));
    }

    function mirror(source, destination) {
      source.addEventListener('change', function () {
        if (destination.value === source.value) return;
        destination.value = source.value;
        syncMinusDisabled(destination);
      });
      source.addEventListener('input', function () {
        if (destination.value === source.value) return;
        destination.value = source.value;
        syncMinusDisabled(destination);
      });
    }

    mirror(mainInput, stickyInput);
    mirror(stickyInput, mainInput);
  }

  function initVariantSelect(select) {
    var sectionId = select.getAttribute('data-section');
    var picker = document.querySelector(
      '#variant-radios-' + sectionId + ', #variant-selects-' + sectionId
    );
    if (!picker) return;

    var jsonScript = picker.querySelector('[type="application/json"]');
    if (!jsonScript) return;
    var variants = JSON.parse(jsonScript.textContent);

    select.addEventListener('change', function () {
      var variant = variants.find(function (v) {
        return String(v.id) === select.value;
      });
      if (!variant) return;

      var fieldsets = picker.querySelectorAll('fieldset');
      fieldsets.forEach(function (fieldset, index) {
        var optionValue = variant.options[index];
        if (optionValue === undefined) return;
        var input = fieldset.querySelector(
          'input[value="' + CSS.escape(optionValue) + '"], option[value="' + CSS.escape(optionValue) + '"]'
        );
        if (input && !input.checked && !input.selected) {
          input.checked = true;
          input.dispatchEvent(new Event('change', { bubbles: true }));
        }
      });
    });
  }

  function initCustomVariantSelect(bar, select) {
    var custom = bar.querySelector('[data-sticky-variant-custom]');
    if (!custom || !select) return;

    var toggle = custom.querySelector('[data-sticky-variant-toggle]');
    var label = custom.querySelector('[data-sticky-variant-label]');
    var optionsList = custom.querySelector('[data-sticky-variant-options]');
    var optionButtons = custom.querySelectorAll('[data-sticky-variant-option]');
    if (!toggle || !label || !optionsList) return;

    function getSelectedOptionText() {
      var selectedOption = select.options[select.selectedIndex];
      return selectedOption ? selectedOption.textContent.trim() : '';
    }

    function setOpen(isOpen) {
      custom.classList.toggle('is-open', isOpen);
      toggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      optionsList.hidden = !isOpen;
    }

    function syncCustomState() {
      label.textContent = getSelectedOptionText();
      optionButtons.forEach(function (button) {
        button.classList.toggle('is-selected', button.dataset.value === select.value);
      });
    }

    toggle.addEventListener('click', function () {
      setOpen(!custom.classList.contains('is-open'));
    });

    optionButtons.forEach(function (button) {
      button.addEventListener('click', function () {
        if (button.disabled) return;
        select.value = button.dataset.value;
        select.dispatchEvent(new Event('change', { bubbles: true }));
        syncCustomState();
        setOpen(false);
      });
    });

    document.addEventListener('click', function (event) {
      if (!custom.classList.contains('is-open') || custom.contains(event.target)) return;
      setOpen(false);
    });

    document.addEventListener('keydown', function (event) {
      if (event.key !== 'Escape' || !custom.classList.contains('is-open')) return;
      setOpen(false);
      toggle.focus();
    });

    select.addEventListener('change', syncCustomState);
    syncCustomState();
  }

  function init() {
    var bar = document.querySelector('[data-sticky-add-to-cart]');
    if (!bar) return;

    initVisibilityObserver(bar);

    var quantityInput = bar.querySelector('[data-sticky-quantity-input]');
    if (quantityInput) {
      initQuantitySync(quantityInput.getAttribute('data-section'));
    }

    var variantSelect = bar.querySelector('[data-sticky-variant-select]');
    if (variantSelect) {
      initVariantSelect(variantSelect);
      initCustomVariantSelect(bar, variantSelect);
    }

    document.addEventListener('variant:change', function (e) {
      var select = bar.querySelector('[data-sticky-variant-select]');
      if (select && e.detail && e.detail.variant) {
        select.value = e.detail.variant.id;
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
